import {
  type QueryHookOptions,
  useQuery,
  type ApolloError,
} from '@apollo/react-hooks';
import { GET_SUPERVISOR_AND_AREA_DATA } from './GET_CHOICE_DATA.gql';

type GetSuperVisorAndArea = {
  researchAreasAndSupervisors?: {
    proposedSupervisors: Array<{ label: string; value: string }>;
    researchAreas: string[];
  };
  loading: boolean;
  error: ApolloError | undefined;
  refetch: () => Promise<any>;
};

export const useGetSupervisorAndArea = (
  options: QueryHookOptions,
): GetSuperVisorAndArea => {
  const { data, loading, error, refetch } = useQuery<GetSuperVisorAndArea>(
    GET_SUPERVISOR_AND_AREA_DATA,
    {
      ...options,
      fetchPolicy: 'network-only',
    },
  );

  return {
    researchAreasAndSupervisors: data?.researchAreasAndSupervisors,
    loading,
    error,
    refetch,
  };
};
